import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { DaysOfWeek, DayOfWeekType } from 'lib/daysOfWeek'

type Props = {
  holidays: DayOfWeekType[]
}

const HolidaysLabel: FC<Props> = (props) => {
  const { holidays } = props
  const daysOfWeek = new DaysOfWeek()

  return (
    <p className={styles.business__holiday}>
      {holidays.length === 0
        ? 'なし'
        : holidays.map((holiday, index) => {
            if (index === 0) {
              return daysOfWeek.getName(holiday)
            } else {
              return ', ' + daysOfWeek.getName(holiday)
            }
          })}
    </p>
  )
}

export default HolidaysLabel
